import cx from 'clsx';
import * as React from 'react';

import * as styles from './iconedLink.css';

export interface IIconedLinkProps {
  text: string;
  link: string;
  icon: React.JSX.Element;
  isDisabled?: boolean;
  onClick?(): void;
}

export const IconedLink = (props: IIconedLinkProps) => (
  <a
    className={cx(styles['container'], props.isDisabled && styles['container--disabled'])}
    href={props.link}
    target="_blank"
    onClick={props.onClick}
    rel="noreferrer"
  >
    {props.icon}
    <span className={styles['text']}>{props.text}</span>
  </a>
);
